"use client"

import { useEffect } from "react"

export function PwaProvider() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/" })
        .then((reg) => {
          console.log("[PWA] Service Worker registrado, scope:", reg.scope)
        })
        .catch((err) => {
          console.error("[PWA] Falha ao registrar Service Worker:", err)
        })
    }
  }, [])

  return null
}
